<template>
  <div class="ExportModal">
    <i class="fas fa-file-csv" @click="showModal"></i>
    <component-modal v-show="condition.condition" transition="expand">

      <template slot="title">
        Export
      </template>

      <div slot="body" class="wrapper">

        <!-- {{columns}} -->

        <div style="display: flex; flex-wrap: wrap">
          <!-- <btn class="m&#45;btn&#45;&#45;column" @click.native="$emit('res')">RESET</btn> -->
          <!-- <btn class="m&#45;btn&#45;&#45;column" @click.native="$emit('all')">ALL</btn> -->
          <!-- <btn class="m&#45;btn&#45;&#45;column" @click.native="$emit('def')">DEFAULT</btn> -->

          <btn v-for="(list, index) in columns" :key="index" class="m-btn--column" @click.native="$emit('swi', index)" v-bind:class="{ 'active': columns[index].show }">{{ list.name }}</btn>

        </div>

      </div>

      <div class="footer" slot="footer">
        <btn class="exportBtn2"><a :href="obj.exportUrl + '&' + exportColumn">export</a></btn>
        <btn @click.native="showModal">戻る</btn>
      </div>

    </component-modal>
  </div>
</template>

<script>
export default {
  props: {
    obj: Object,
    columns: Array
  },

  name: 'ExportModal',

  data () {
    return {
      condition: {
        condition: false
      }
    }
  },

  computed: {
    exportColumn () {
      const trueArr = this.columns.filter(col => {
        return col.show === true
      })
      let param = ''
      for (let i = 0; i < trueArr.length; i++) {
        param += 'columns[]=' + trueArr[i].code + '&'
      }
      return param
    }
  },

  methods: {
    showModal () {
      this.condition.condition = !this.condition.condition
    }
  }
}
</script>

<style lang='scss' scoped>
.fa-file-csv {
  font-size: 25px;
  padding: 5px;
  color: #37474f;
  cursor: pointer;
}

.export-btn {
  height: 15px;
  width: 100px;
  padding: 0;
  background-color: transparent;
  border: 1px solid #ccc;
  color: #000;
  font-weight: normal;
  font-size: 10px;
  margin-right: 1px;
  margin-bottom: 1px;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
.wrapper {
  display: flex;
  flex-flow: column;
  /* border-top: solid 1px #ccc; */
  max-height: 340px;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.table {
  margin: 0;
}
.footer {
  width: 100%;
  display: flex;
  .m-btn + .m-btn {
    margin-top: 0;
  }
}
</style>
<style lang="scss">
.ExportModal {
  .exportBtn1 {
    transition: all 0.3s ease-in-out 0s;
    &:hover {
      background: #334750;
      color: #fff;
      font-weight: bold;
      border: 1px solid #334750;
    }
  }
  .exportBtn2 {
    padding: 0;
    a {
      color: #fff;
      text-decoration: none;
      width: 100%;
      height: 46px;
      padding-top: 13px;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ExportModal.vue?cf77bd0c